import { render, staticRenderFns } from "./resultExample.vue?vue&type=template&id=4f014d04&scoped=true&"
import script from "./resultExample.vue?vue&type=script&lang=js&"
export * from "./resultExample.vue?vue&type=script&lang=js&"
import style0 from "./resultExample.vue?vue&type=style&index=0&id=4f014d04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f014d04",
  null
  
)

export default component.exports